const pending: Record<'proposal' | 'quotation', File[]> = { proposal: [], quotation: [] };

export function stashPendingOfferFiles(kind: 'proposal' | 'quotation', files: File[]): void {
  pending[kind] = files;
}

export function peekPendingOfferFiles(kind: 'proposal' | 'quotation'): File[] {
  return pending[kind];
}

export function takePendingOfferFiles(kind: 'proposal' | 'quotation'): File[] {
  const files = pending[kind];
  pending[kind] = [];
  return files;
}
